import { environment } from '../environments/environment';
export type EnvironmentName = 'dev' | 'test' | 'prod' | 'azgeo';

export class AppSettings {
	public static appName = environment.appName;
	static envName: EnvironmentName = (<EnvironmentName>environment.envName);

	public static authLogoUrl = environment.authLogoUrl;
	// public static sharedRootUrl = environment.sharedRootUrl;
	public static serviceRootUrl = environment.serviceRootUrl;
	public static socketConnectOption = environment.socketConnectOption;
	public static rootLink = environment.rootLink;
	public static portalRootLink = environment.portalRootLink;
	public static idleTime = environment.idleTime;
	public static loginPortal = environment.loginPortal;
	//
	public static elasticsearchHost = environment.elasticsearchHost;

	// LBPortal related
	public static lbPwResetUrl = environment.lbPortalPwResetUrl;
	public static lbRegisterUrl = environment.lbPortalRegisterUrl;
}
